module.exports = __webpack_public_path__ + "media/images/lb/417-1354e9bb68f9f5afeda9bf666763ca65.svg";